import { render, staticRenderFns } from "./BusinessConsultationEdit.vue?vue&type=template&id=f16e57c8&"
import script from "./BusinessConsultationEdit.vue?vue&type=script&lang=js&"
export * from "./BusinessConsultationEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports